import AuthRedirectToSignInEvent from './/AuthRedirectToSignInEvent';
import AuthForgotUserNameErrorEvent from './AuthForgotUserNameErrorEvent';
import AuthRedirectToDefaultEvent from './AuthRedirectToDefaultEvent';
import AuthRedirectToForgotPasswordEmailEvent from './AuthRedirectToForgotPasswordEmailEvent';
import AuthRedirectToForgotUserNameEmailEvent from './AuthRedirectToForgotUserNameEmailEvent';
import AuthRedirectToOtpEvent from './AuthRedirectToOtpEvent';
import AuthRedirectToUpdatePasswordEvent from './AuthRedirectToUpdatePasswordEvent';

const AuthEvents = {
  RedirectToForgotPasswordEmail: AuthRedirectToForgotPasswordEmailEvent,
  ForgotUserNameError: AuthForgotUserNameErrorEvent,
  RedirectToForgotUserNameEmail: AuthRedirectToForgotUserNameEmailEvent,
  RedirectToOtp: AuthRedirectToOtpEvent,
  RedirectToDefault: AuthRedirectToDefaultEvent,
  RedirectToUpdatePassword: AuthRedirectToUpdatePasswordEvent,
  RedirectToSignIn: AuthRedirectToSignInEvent,
};

export default AuthEvents;
